'use strict';

class AccountOriginators {
  constructor(originatorService, Notification) {
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.originatorId = null;

    this.email = null;
    this.users = {
      linked: [],
      pending: []
    };

    this.load();
  }

  load() {
    this.originatorService.get()
      .then((originator) => {
        this.originatorId = originator.data.id;

        this.originatorService.getUsersOfOriginator(this.originatorId)
          .then((resp) => {
            this.users = {
              linked: resp.data.users,
              pending: resp.data.pending
            };
          });
      });
  }

  removeLinkedUsers(id) {
    this.originatorService.removeLinkedUsers(this.originatorId, id)
      .then(() => this.load());
  }

  revokeRequest(email) {
    this.originatorService.removeInvite(this.originatorId, email)
      .then(() => this.load());
  }

  inviteOriginator() {
    if (this.email !== null && this.email !== '') {
      this.originatorService.inviteOriginator(this.originatorId, this.email)
        .then(() => {
          this.Notification.info('Invitasjonen er sendt');
          this.email = null;

          this.load();
        })
        .catch((err) => this.Notification.error(err.data));
    } else {
      this.Notification.error('E-postadresse er påkrevd');
    }
  }
}

AccountOriginators.$inject = ['originatorService', 'Notification'];

const accountOriginators = {
  controller: AccountOriginators,
  template: `
    <h2>Tilgang</h2>

    <account-tabs active-tab="users"></account-tabs>

    <p>For &aring; endre dine egne innstillinger g&aring; til <a href="#/bruker">Brukerinnstillinger</a></p>

    <fieldset ng-show="$ctrl.users.linked.length">
      <h3 class="subheader">Godkjente brukere</h3>
      <p>Personer som har tilgang til denne SendRegning-kontoen.</p>
      <table>
        <thead>
          <tr>
            <th>Navn</th>
            <th>E-post</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="linked in $ctrl.users.linked track by $index">
            <td>{{ linked.name }}</td>
            <td>{{ linked.userName }}</td>
            <td><i class="fa fa-times" ng-click="$ctrl.removeLinkedUsers(linked.userId)"></i></td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <fieldset ng-show="$ctrl.users.pending.length">
      <h3 class="subheader">Inviterte brukere</h3>
      <p>Personer som har blitt tilbudt adgang til kontoen, men ikke har akseptert enn&aring;.</p>
      <table>
        <thead>
          <tr>
            <th>E-post</th>
            <th>Dato</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="pending in $ctrl.users.pending track by $index">
            <td>{{ pending.email }}</td>
            <td>{{ pending.sent }}</td>
            <td><i class="fa fa-times" ng-click="$ctrl.revokeRequest(pending.email)"></i></td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <form ng-submit="$ctrl.inviteOriginator()" novalidate ng-cloak>
      <fieldset>
        <h3 class="subheader">Gi tilgang til kontoen din</h3>
        <div>
          <label for="email">E-postadresse</label>
          <input type="email" id="email" name="email" ng-model="$ctrl.email" maxlength="64" placeholder="ola@nordmann.no" required>
          <button type="submit" class="button">Send invitasjon</button>
        </div>
      </fieldset>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('accountOriginators', accountOriginators)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/tilgang', {
        title: 'Tilgang',
        template: '<account-originators />',
        secure: true
      });
  });
